import { render } from "./DisableGoogle2fa.vue?vue&type=template&id=236ef7a3"
import script from "./DisableGoogle2fa.vue?vue&type=script&lang=js"
export * from "./DisableGoogle2fa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/DisableGoogle2fa.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "236ef7a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('236ef7a3', __exports__)) {
    api.reload('236ef7a3', __exports__)
  }
  
  module.hot.accept("./DisableGoogle2fa.vue?vue&type=template&id=236ef7a3", () => {
    api.rerender('236ef7a3', render)
  })

}


export default __exports__